// TODO: support responsiveness
var spacings = {
  xxxSmall: '0.125rem',
  // 2px
  xxSmall: '0.375rem',
  // 6px
  xSmall: '0.75rem',
  // 12px
  small: '1rem',
  // 16px
  medium: '1.5rem',
  // 20px
  large: '2.25rem',
  // 36px
  xLarge: '3rem',
  // 48px
  xxLarge: '3.75rem',
  // 60px
  xxxLarge: '4.5rem',
  // 72px
  xxxxLarge: '5.25rem' // 84px

};

export { spacings };
//# sourceMappingURL=spacings.js.map
